import { render, staticRenderFns } from "./allgoods.vue?vue&type=template&id=743d3420&scoped=true"
import script from "./allgoods.vue?vue&type=script&lang=js"
export * from "./allgoods.vue?vue&type=script&lang=js"
import style0 from "./allgoods.vue?vue&type=style&index=0&id=743d3420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743d3420",
  null
  
)

export default component.exports